import {
  Toast,
  useModalManager,
  useToastManager,
} from 'plataforma-fundacao-componentes';
import React, { createContext, Fragment } from 'react';

interface LayoutType {
  openModal: <C extends React.ElementType<any>>(
    _component: C,
    _modalProps: React.ComponentProps<C>
  ) => void;
  closeModal: (_modalKey: string | number) => void;
  showToast: (_toast: React.ComponentProps<typeof Toast>) => void;
  clearToasts: () => void;
}

export const LayoutContext = createContext<LayoutType>({
  openModal: <C extends React.ElementType<any>>(
    _component: C,
    _modalProps: React.ComponentProps<C>
  ) => {},
  closeModal: (_modalKey: string | number) => {},
  showToast: (_toast: React.ComponentProps<typeof Toast>) => {},
  clearToasts: () => {},
});

export default function LayoutProvider({ children }: { children: any }) {
  const [ModalManager, openModal, closeModal] = useModalManager();
  const [ToastManager, showToast, clearToasts] = useToastManager({
    verticalPosition: 'top',
    horizontalPosition: 'right',
    animateSize: false,
    marginTop: '12px',
    max: 50,
    pauseOnFocusLoss: true,
    reverse: true,
  });

  return (
    <LayoutContext.Provider
      value={{ openModal, closeModal, showToast, clearToasts }}
    >
      <Fragment>
        {children}
        {ModalManager}
        {ToastManager}
      </Fragment>
    </LayoutContext.Provider>
  );
}
